/**
 * Types and constants for Performance Settings components
 */
import { SupplierPerformanceSettings, SupplierRatingThreshold, CreateRatingThresholdData } from '../../../lib/api';

export const MONTH_OPTIONS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

export const WEEK_DAY_OPTIONS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

export const GRADE_COLORS: Record<string, string> = {
  A: '#22c55e',
  B: '#84cc16',
  C: '#eab308',
  D: '#f97316',
  F: '#ef4444',
};

export interface PerformanceFormData {
  otif_excellent_threshold: string;
  otif_good_threshold: string;
  otif_poor_threshold: string;
  ppm_excellent_threshold: number;
  ppm_good_threshold: number;
  ppm_poor_threshold: number;
  otif_weight: string;
  ppm_weight: string;
  otif_days_early_allowed: number;
  otif_days_late_allowed: number;
  include_arrears_in_otif: boolean;
  delivery_metric_mode: 'both' | 'otif_only' | 'otd_only';
}

export interface ThresholdEditData {
  grade: string;
  label: string;
  min_score: string;
  max_score: string;
  color: string;
  description: string;
  order: number;
}

export interface SupplierEditData {
  use_custom_otif_window: boolean;
  otif_days_early_allowed: number;
  otif_days_late_allowed: number;
}

export interface SupplierOTIFData {
  id: number;
  company__name: string;
  use_custom_otif_window: boolean;
  otif_days_early_allowed: number;
  otif_days_late_allowed: number;
}

// Re-export API types for convenience
export type { SupplierPerformanceSettings, SupplierRatingThreshold, CreateRatingThresholdData };
